import React, { Component } from "react";

export default class SignUpBody extends Component {
  render() {
    return <div id="mx-auto company-selection-grid-container clearfix">{this.props.content}</div>;
  }
}
